export default __webpack_public_path__ + "static/media/Ун_40л.c7d10249.jpg";